import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useSelf = () => {
  const urlStr = `${getApiUrl()}/self`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useUsers = (params) => {
  const q = params?.get('q');
  const isCoach = params?.get('isCoach');

  const query = new URLSearchParams();
  if (q) {
    query.set('q', q);
  }
  if (isCoach) {
    query.set('isCoach', isCoach);
  }

  const urlStr = `${getApiUrl()}/mega/user${
    query.size > 0 ? `?${query.toString()}` : ''
  }`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const useUser = (id) => {
  const urlStr = `${getApiUrl()}/mega/user/${id}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const usePutSelf = () => {
  const putTenant = async (payload) => {
    try {
      const url = `${getApiUrl()}/self`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putTenant;
};

export const useChangePassword = () => {
  const changePassword = async (payload) => {
    try {
      const url = `${getApiUrl()}/self/change-password`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return changePassword;
};
